import { render, staticRenderFns } from "./v-accordion.vue?vue&type=template&id=f9d59d28&scoped=true&"
import script from "./v-accordion.vue?vue&type=script&lang=js&"
export * from "./v-accordion.vue?vue&type=script&lang=js&"
import style0 from "./v-accordion.vue?vue&type=style&index=0&id=f9d59d28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d59d28",
  null
  
)

export default component.exports